$('.card-team .btn').on('click', function () {
  $(this).parents(".card-team").toggleClass('active').trigger('classChange');
});



export default function CardTeam() {
  $('.card-team').each(function () {
    let cardTeam = $(this);
    let descriptionHeight = cardTeam.find('.description p').innerHeight();
    let bodyHeight = cardTeam.find('.body').innerHeight();
    let toggleBtn = cardTeam.find('.btn-link');
    
    if(descriptionHeight < bodyHeight) {
      toggleBtn.css('display', 'none');
      cardTeam.removeClass('active');
    }
    else {
      toggleBtn.css('display', 'flex');
    }
    
    cardTeam.one('classChange', function() {
      let descriptionHeightTemp = cardTeam.find('.description p').innerHeight();
      if (cardTeam.hasClass('active') && descriptionHeightTemp > cardTeam.innerHeight()) {
        cardTeam.css('min-height', (descriptionHeightTemp + 24));
      }
    });
  });
}


